// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.emd-mundi-logo_alt {\n  display: inline-block;\n  position: relative;\n  width: 122px;\n}\n.mundi-beta_alt {\n  position: absolute;\n  left: 0;\n  bottom: 33px;\n  font-size: 10px;\n  font-weight: 600;\n  text-transform: lowercase;\n}\n", ""]);
// Exports
module.exports = exports;
